define(function (require) {
	const Backbone = require('backbone');
	const Modal = require('backbone.modal');
	const Radio = require('backbone.radio');
	const ViewManager = require('civicsUtils/view_manager');
	const invitation_model = require('civicsModels/portal/authorized_user_invitation_model');
	const AddAuthorizedUsersInvitationTemplate = require('civicsViews/InviteAuthorizedUsers/templates/t_cpv_invite_authorized_users.hbs');
	const authorizedUsersRowItemView = require('civicsViews/InviteAuthorizedUsers/v_itv_invite_authorized_users');
	const Utils = require('civicsUtils/general_utilities');
	const constants = require('civicsUtils/constants');
    const DateUtils = require('civicsUtils/date_utilities');

	return Marionette.CompositeView.extend({
		template: AddAuthorizedUsersInvitationTemplate,
		childView: authorizedUsersRowItemView,
		childViewContainer: '.invitation-items',
		childEvents: {
			'invitation-item:remove': 'onRemoveInvitationItem',
		},
		ui: {
			newButton: '.invitations-add-new .btn-secondary',
			saveButton: '.save-invite',
			cancelButton: '.cancel-invite',
			closeButton: '.bbm-btn-close',
			listViewerHeader: '.list-view-header',
		},
		events: {
			'click @ui.newButton': 'addInvitation',
			'click @ui.saveButton': 'onSaveNewInvitations',
			'click @ui.cancelButton': 'closeInviteApplicantModal',
			'click @ui.closeButton': 'closeInviteApplicantModal',
		},
		initialize: function (options) {
			this.config = options.config ? options.config : {};
			this.modalRegion = options.modalRegion;
			this.collection = options.collection,
			this.invitationsCollection = options.invitationsCollection,
			this.isAddProcess = options.isAddProcess,
			this.addInvitation();
			if (options.primaryApplicant) {
				this.primaryApplicant = options.primaryApplicant;
			}
		},
		childViewOptions:function(model, index){
			return {
				config: this.config,
				invitationsCollection: this.invitationsCollection
			}
		},
		onShow: function () {

		},
		onRender: function(){
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			ViewManager.resetErrorMessages(this);
		},
		addInvitation: function () { 
			var model = new invitation_model();
			var id = this.collection.length + 1;

			// Preserving changes made by the user before re-rendering
			_.each(this.collection.models, function(model) {
				var view = this.children.findByModel(model);
				var data = view.getData(null);
				this.setModel(model, data);
				id = model.id >= id ? model.id + 1 : id;
			}, this);

			var rowData = {
				id: id,
				authorizedUserRole: '',
				authorizedUserEmail: '',
				inviteStatus: '',
				authorizedUserEffectiveDateTime: '',
			};

			model.set(rowData);
			model.id = id; // Ensure the model's ID is updated correctly
		
			this.collection.add(model);
			this.render(); // Re-render the view to show the new row
		},
		setModel: function(model, data) {
			let effectiveDateTime = this.effectiveDateTime(data.effectiveDate, data.effectiveTime);

			// Updates the model with the new user data input
			var dataobj = {
				"id": model.id,
				"isValid": data.isValid,
				"authorizedUserEmail": data.authorizedUserEmail,
				"authorizedUserRole": data.authorizedUserRole === 'Admin',
				"authorizedUserEffectiveDateTime": effectiveDateTime
			};
			model.set(dataobj);
		},
		effectiveDateTime: function (effectiveDate, effectiveTime) {
			if (effectiveDate && effectiveTime) {
				// due to change on using moment.js, the .isValid() and .format() is not working anymore. Use the dateutils to format it to YYYY-MM-DD[T]HH:mm:ss
				return DateUtils._formatAsISO(Utils.createMoment(`${effectiveDate} ${effectiveTime}`));
			}
			return null;
		},
		onSaveNewInvitations: function (data, model) {
			ViewManager.resetErrorMessages(this);
			ViewManager.loading(true);
			var newInvitations = [];
			var errorsFound = false;
			this.addInvitePromise = $.Deferred();

			// save invitation item(s)
			var self = this;
			self.children.each(function (view, index) {
				var data = view.getData();
				if(!data.isValid){
					errorsFound = true;
				} else {
					// Combine effectiveDate and effectiveTime into a single datetime
					let effectiveDateTime = self.effectiveDateTime(data.effectiveDate, data.effectiveTime);
					newInvitations.push({
						organizationId: App.user.id,
						authorizedUserEmail: data.authorizedUserEmail,
						authorizedUserRole: data.authorizedUserRole,
						authorizedUserEffectiveDateTime: effectiveDateTime,
					});
				}
			});

			if(errorsFound) {
				ViewManager.loading(false);
				return;
			}
			// Saving and sending of invitations
			var savePromise = self.saveInvitations(newInvitations);

			$.when(savePromise).done(function() {
				Utils.civicsToastPop(i18n.t('CIVICS.ORGANIZATION_PROFILE_INFO.AUTH_USERS_SENT_INVITE_CONFIRMATION'), "success");
				self.triggerMethod('invitation:added', newInvitations);
				self.closeInviteApplicantModal();
				ViewManager.loading(false);
			});
		},
		saveInvitations: function(newInvitation) {
			var def = new $.Deferred();
		
			var invitationsArr = [];
			_.each(newInvitation, function(invite) {
				invitationsArr.push({
					"OrganizationId": invite.organizationId,
					"SentTo": invite.authorizedUserEmail,
					"Roles": [invite.authorizedUserRole],
					"EffectiveDate": invite.authorizedUserEffectiveDateTime
				});
			});
		
			var invitationModel = new invitation_model();
			invitationModel.set({
				"OrganizationId": newInvitation[0].organizationId, 
				"Invitations": invitationsArr
			});
		
			invitationModel.save(null, {
				// type: 'PUT'
				success: function (model, response, options) {
					// Update each invitation in newInvitation with the corresponding response data
					_.each(response.data, function(responseInvite, index) {
						var invite = newInvitation[index];
						invite.id = responseInvite.id;
						invite.sentTo = responseInvite.sentTo;
						invite.isAdmin = responseInvite.isAdmin;
						invite.sender = responseInvite.sender;
						invite.inviteExpireDate = responseInvite.expiredDate;
						invite.status = responseInvite.status;
						invite.invitationCode = responseInvite.invitationCode;
					});
					def.resolve();
				},
				error: function (model, response, options) {
					def.reject();
					let alertMessage = i18n.t('CIVICS.ORGANIZATION_PROFILE_INFO.AUTH_USER_SENDING_INVITE_ERROR');
					ViewManager.loading(false);
					ViewManager.openAlert(alertMessage);
				}
			});
			return def.promise();
		},
		onRemoveInvitationItem: function (childView) {
			this.collection.remove(this.collection.get({cid: childView.model.cid}));

			this.removeChildView(childView);
			childView.destroy();

			this.ui.saveButton.prop("disabled", (this.collection.length <= 0));
		},
		closeInviteApplicantModal: function (e, myModel) {
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},
		templateHelpers: function() {
			return {
				config: this.config,
			};
		},
	});
});
